import { Box, Typography } from '@mui/material';
import { colors } from '../../../styles/colors';
import { monoFontFamily } from '../scriptsStyles';

interface ProgressBarProps {
  items: Array<{ label: string; color: string; percent: number }>;
}

export const ProgressBar = ({ items }: ProgressBarProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%', minWidth: 0 }}>
      <Box
        role="img"
        aria-label={items.map((item) => item.label).join(', ')}
        sx={{
          display: 'flex',
          width: '100%',
          height: 12,
          borderRadius: 999,
          overflow: 'hidden',
          backgroundColor: 'rgba(255, 255, 255, 0.06)',
        }}
      >
        {items.map((item) => (
          <Box
            key={item.label}
            sx={{ width: `${item.percent}%`, bgcolor: item.color, transition: 'width 0.4s ease' }}
          />
        ))}
      </Box>
      <Box sx={{ display: 'flex', gap: '4px 14px', flexWrap: 'wrap' }}>
        {items.map((item) => (
          <Box
            key={item.label}
            sx={{ display: 'flex', alignItems: 'center', gap: 0.75, opacity: item.percent > 0 ? 1 : 0.55 }}
          >
            <Box sx={{ width: 7, height: 7, bgcolor: item.color, borderRadius: '2px', flexShrink: 0 }} />
            <Typography
              sx={{
                fontFamily: monoFontFamily,
                fontSize: '11px',
                color: colors.brand.textSecondary,
                whiteSpace: 'nowrap',
              }}
            >
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
